/**
 * API Configuration
 * Central configuration for all API endpoints and base URL
 */

export const API_CONFIG = {
  BASE_URL: "https://fi-api.ahdus.de/api",
  // BASE_URL: "http://192.168.1.79:3001/api",
  TIMEOUT: 10_000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 second
} as const

export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: "/users/login",
    REFRESH_TOKEN: "/users/refresh-token"
  },

  // Client endpoints
  CLIENTS: {
    LIST: "/clients",
    GET_BY_ID: (id: string) => `/clients/${id}`,
    GET_DETAILS: "/clients/details",
    DELETE: (id: string) => `/clients/${id}`,
    BULK_DELETE: "/clients/bulk-delete",
    CREATE_INVITATION: "/client-invitations",
    UPLOAD_EXCEL: "/clients/upload-excel",
    GET_INVITATION_FORM: (token: string) => `/client-invitations/${token}/form`,
    SAVE_INVITATION_STEP: (token: string, categoryId: number) =>
      `/client-invitations/${token}/steps/${categoryId}`
  }
} as const

export type ApiEndpoint = typeof API_ENDPOINTS
export type ApiConfig = typeof API_CONFIG
